import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BANNER_MESSAGES } from 'src/app/core/constants/General-constants';
import { Payment, Transaction } from 'src/app/models';
import { AuthService } from 'src/app/services/auth.service';
import { PaymentMethodsService } from 'src/app/services/payment-methods.service';
import { PayvalidaFeatureFlagService } from 'src/app/services/payvalida-feature-flag.service';
import { TokenServiceService } from 'src/app/services/token-service.service';
import { GeneralTool } from '../split-payment/tools/general-tools';

@Component({
  selector: 'app-peru-payment-services',
  templateUrl: './peru-payment-services.component.html',
  styleUrls: ['./peru-payment-services.component.scss']
})
export class PeruPaymentServicesComponent implements OnInit {
  @Input() information: Payment;
  @Input() transaction: Transaction;
  @Output() PERUMETHODS = new EventEmitter();

  loading = false;
  template: string;
  orderID: string;
  token = '';
  userType = 'Depósito';
  stepFourMsg = '';
  bbvaPeruCode = 370;

  banerMessage: string = BANNER_MESSAGES.DEPOSIT_RECOMENDATION;
  merchantHasWallet: boolean;

  private parameter = 'peru_cash_banner';
  private flag = 'recommendationBannersForPaymentMethodsFF';
  private platform = 'payvalida';
  bannerRecommedationFF: boolean = false;

  private parameter2 = 'bannerRecommedationUiFixFF';
  private flag2 = 'bannerRecommedationUiFixFF';
  private platform2 = 'payvalida';
  bannerRecommedationUiFixFF: boolean = false;

  constructor(
    private tokenService: TokenServiceService,
    private authService: AuthService,
    private readonly paymentMethodsService: PaymentMethodsService,
    private featureFlagService: PayvalidaFeatureFlagService) { }

  ngOnInit(): void {
    this.onActivate();

    this.featureFlagService.getFeatureFlagValue(this.parameter, this.flag, this.platform).subscribe((response: boolean) => {
      this.bannerRecommedationFF = response;
    });

    this.featureFlagService
      .getFeatureFlagValue(this.parameter2, this.flag2, this.platform2)
      .subscribe((response: boolean) => {
        this.bannerRecommedationUiFixFF = response;
      });

    const token = this.tokenService.getToken();

    this.paymentMethodsService.paymentMethods(token).subscribe((data: any) => {
      const merchantHasWallet = GeneralTool.checkMerchantHasWallet(data);

      if (merchantHasWallet) {
        this.merchantHasWallet = true;
      }
    });

    this.loading = false;
    this.template = this.information.template;
    this.orderID = this.authService.getOrderID();
    this.transaction = this.tokenService.getAndDecodeToken();
    this.token = this.tokenService.getToken();
    this.stepFourMsg = this.information.code == this.bbvaPeruCode ? 'peru-pay-step-four-bbva' : 'peru-pay-step-four-scotia-Bank';
  }

  /**
   * @description Function that returns to payment methods
   */
  changeMethod() {
    this.PERUMETHODS.emit();
  }

  /**
   * @description {onActivate}
   */
  onActivate() {
    window.scroll(0, 0);
  }

}
